module.exports = "/_next/static/images/guanyuwomen@3x-8d9ca2a48876a149c6f364e42354bdb4.png";